import React from 'react'
import { ContactsTable } from 'components/Tables/ContactsTable/ContactsTable'
import { ContactCompany } from 'models/companies'
import { CompanyModal } from '../CompanyModal'
import { TableLinkStyleProvider } from 'components/Tables/CommonTableCells/TableLinkStyleContext'
import { StageColorProvider } from 'components/SalesStage/StageColorContext'
import {
  CONTACTS_MODAL_COLUMN_ORDER,
  CONTACTS_MODAL_TABLE_KEY,
} from 'constants/tableQueryKeys'

interface ContactsModalProps {
  show: boolean
  onHide: () => void
  contactCompany: ContactCompany
  forDoorProxyId?: number
  companyName?: string
}

export function ContactsModal({
  show,
  onHide,
  contactCompany,
  forDoorProxyId,
  companyName,
}: ContactsModalProps) {
  return (
    <CompanyModal
      show={show}
      onHide={onHide}
      companyName={companyName || contactCompany.name}
      modalTitle="Contacts"
    >
      <TableLinkStyleProvider variant="plain">
        <StageColorProvider value="pipeline">
          <div
            className="flex flex-col overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-[0px_1px_3px_0px_rgba(16,24,40,0.08),0px_1px_2px_-1px_rgba(16,24,40,0.04)]"
            style={{ height: '60vh' }}
          >
            <ContactsTable
              defaultColumnVisibility={{
                requested_contact__campaign__name: false,
              }}
              // Company-agnostic key so the user's column layout persists when
              // switching companies/doors. Data is scoped via forCompany /
              // forDoorProxyId, not the table key (FIR-7301).
              tableKey={CONTACTS_MODAL_TABLE_KEY}
              initialColumnOrder={CONTACTS_MODAL_COLUMN_ORDER}
              forCompany={contactCompany}
              forDoorProxyId={forDoorProxyId}
              disableUrlPagination
              disableExportButton
            />
          </div>
        </StageColorProvider>
      </TableLinkStyleProvider>
    </CompanyModal>
  )
}
